import { render, staticRenderFns } from "./TextDialog.vue?vue&type=template&id=759aacee&scoped=true&"
import script from "./TextDialog.vue?vue&type=script&lang=js&"
export * from "./TextDialog.vue?vue&type=script&lang=js&"
import style0 from "./TextDialog.vue?vue&type=style&index=0&id=759aacee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "759aacee",
  null
  
)

/* custom blocks */
import block0 from "./TextDialog.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports